import { getFormatE164, getFormatNational } from '../../utils/normalize-phone';
import type { AppDB } from '../db';
import { Entity } from 'dexie';

class User extends Entity<AppDB> {
  public uid: number;
  public uid_news: number;
  public firstname: string;
  public lastname: string;
  public mail: string;
  public password_force_change: boolean;
  public is_administrator: boolean;
  public is_supervisor: boolean;
  public allow_service_list: string;
  public allow_poi_list: string;
  public sum_forbiden_tab_list: number;
  public sum_forbiden_tab_write_list: number;
  public stat_access: boolean;
  public mail_export: boolean;
  public version_log: string;
  public phone: string;
  public session_count: number;
  public update_mission: boolean;
  public update_planning: boolean;
  public update_poi: boolean;

  get poi_list_array() {
    return this.is_administrator || this.is_supervisor
      ? [-1]
      : this.allow_poi_list !== ''
        ? this.allow_poi_list.split(',').map(Number)
        : [0];
  }

  get service_list_array() {
    return this.is_administrator || this.is_supervisor
      ? [-1]
      : this.allow_service_list !== ''
        ? this.allow_service_list.split(',').map(Number)
        : [0];
  }

  set poi_list_array(value) {
    this.allow_poi_list = value.join(',');
  }

  set service_list_array(value) {
    this.allow_service_list = value.join(',');
  }

  get fullName() {
    return `${this.firstname} ${this.lastname} `;
  }

  get role() {
    if (this.is_supervisor) return { label: 'USER.ISSUP', value: 'supervisor' } as const;
    if (this.is_administrator) return { label: 'USER.ISADMIN', value: 'administrator' } as const;
    return { label: 'USER.ISUSER', value: 'user' } as const;
  }

  public get phoneNational(): string | null {
    return getFormatNational(this.phone);
  }

  public get phoneE164() {
    return getFormatE164(this.phone);
  }
}

export default User;
